import { useEffect } from 'react';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${SITE_URL}/#business`,
  name: 'Susana Asesora de Salud',
  description:
    'Asesoría personalizada en salud previsional en Santiago y todo Chile. Orientación comercial, cotización y acompañamiento cercano para planes de salud Isapre Consalud.',
  url: SITE_URL,
  telephone: '+56944540956',
  email: 'susana@asesora-salud.cl',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Santiago',
    addressRegion: 'Región Metropolitana',
    addressCountry: 'CL',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: -33.4489,
    longitude: -70.6693,
  },
  areaServed: {
    '@type': 'Country',
    name: 'Chile',
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '19:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Saturday'],
      opens: '10:00',
      closes: '14:00',
    },
  ],
  priceRange: 'Gratis',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+56944540956',
    contactType: 'customer service',
    availableLanguage: 'Spanish',
    contactOption: 'TollFree',
  },
  sameAs: [`https://wa.me/56944540956`],
};

const personSchema = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Susana',
  jobTitle: 'Ejecutiva Comercial de Salud Previsional',
  worksFor: {
    '@type': 'Organization',
    name: 'Consalud Isapre',
  },
  url: SITE_URL,
  telephone: '+56944540956',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Santiago',
    addressRegion: 'Región Metropolitana',
    addressCountry: 'CL',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '¿Esta página es oficial de Consalud?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No, este es mi sitio web personal de orientación y acompañamiento comercial. No corresponde al sitio oficial de Consalud. Trabajo como ejecutiva vinculada a la isapre, pero la contratación y formalización de productos se realiza por los canales autorizados oficiales.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Puedo resolver dudas sobre planes y beneficios?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sí, por supuesto. Te ayudo a entender las diferencias entre planes, coberturas, bonificaciones y beneficios. Mi objetivo es que tengas toda la información clara para tomar la mejor decisión.',
      },
    },
    {
      '@type': 'Question',
      name: '¿La orientación tiene costo?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No, la orientación y asesoría que brindo no tiene costo. Es parte del servicio de acompañamiento que ofrezco para ayudarte a entender y gestionar mejor tu salud previsional.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Dónde es la atención?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'La atención presencial es en Santiago. Si estás en otra región de Chile, también puedo atenderte sin problema a través de videollamada. La distancia no es un obstáculo para orientarte y resolver tus dudas.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Cómo puedo contactarte?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Puedes escribirme directamente por WhatsApp haciendo clic en el botón de contacto, o completar el formulario en esta página. Respondo rápidamente y estoy disponible para resolver tus dudas.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Qué pasa después de contratar un plan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No te dejo solo. Ofrezco seguimiento y apoyo postventa para resolver cualquier duda que surja sobre tu plan, beneficios o gestiones. Estoy disponible cuando me necesites.',
      },
    },
  ],
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Asesoría en Planes de Salud Isapre',
  description:
    'Orientación personalizada, cotización, evaluación y acompañamiento comercial en planes de salud Isapre Consalud para personas en Santiago y todo Chile.',
  provider: {
    '@type': 'LocalBusiness',
    name: 'Susana Asesora de Salud',
    url: SITE_URL,
  },
  areaServed: {
    '@type': 'Country',
    name: 'Chile',
  },
  serviceType: 'Asesoría en salud previsional',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'CLP',
    description: 'Orientación comercial gratuita para planes de salud',
  },
};

export default function SeoSchema() {
  useEffect(() => {
    const schemas = [localBusinessSchema, personSchema, faqSchema, serviceSchema];

    const existingScripts = document.querySelectorAll('script[data-seo-schema]');
    existingScripts.forEach((s) => s.remove());

    schemas.forEach((schema, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-schema', String(i));
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-seo-schema]').forEach((s) => s.remove());
    };
  }, []);

  return null;
}
